const $ = jQuery;
import loadingSvg from "../assets/loadingSvg.svg";

class MediaKitCompleteFlow {
	constructor(myGamePlanActions) {
		this.btnMediakitFlagComplete = $("#btn-mediakit-flag-complete");
		this.myGamePlanActions = myGamePlanActions;
	}

	handleClick = () => {
		const mediakit_complete_btn = this.btnMediakitFlagComplete;

		mediakit_complete_btn.prop("disabled", true);
		mediakit_complete_btn.html(`<span class="loading"><img src="${loadingSvg}" class="loading-svg"></span>`);

		this.myGamePlanActions.markCompleted(0, () => {
			mediakit_complete_btn.text("Done!");

			setTimeout(() => {
				mediakit_complete_btn.hide();
				mediakit_complete_btn.prop("disabled", false);
			}, 3000);
		}, () => {
			mediakit_complete_btn.text('I\'ve completed my Media Kit!');
			mediakit_complete_btn.prop("disabled", false);
		});
	};

	init = () => {
		if (this.btnMediakitFlagComplete.length > 0) {
			this.btnMediakitFlagComplete.on("click", this.handleClick);
		}
	}
}

export default MediaKitCompleteFlow;
